import InCardStack from 'components/atoms/container/InCardStack'
import SelfAssessmentCard from 'components/organisms/assessments/SelfAssessmentCard'

const StepFour = ({ selectedGoal, completeCallback }) => {

  const handleSubmit = () => {
    completeCallback()
  }

  return (
    <InCardStack width='100%' spacing={10}>
      <SelfAssessmentCard
        goalId={selectedGoal.id}
        nextStepCallback={handleSubmit}
      />
    </InCardStack>
  )
}

export default StepFour
